/**
* @Author: Matthias Gohla <Matze>
* @Date:   2016-07-29T15:35:34+02:00
* @Email:  matze_lebt@gmx.de
* @Last modified by:   mBook
* @Last modified time: 2016-09-20T11:34:59+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';

export const TINY = 'tiny';
export const SMALL = 'small';
export const NORMAL = 'normal';
export const BIG = 'big';
export const HUGE = 'huge';
export const sizes = {
  tiny: TINY,
  small: SMALL,
  normal: NORMAL,
  big: BIG,
  huge: HUGE,
};

/**
 * AIconInline - …
**/
class AIconInline extends Component {
  render() {
    const {
      icon,
      children = icon,
      size,
      style,
    } = this.props;
    return (<span style={style} className={`a-icon a-icon-inline glyphicons glyphicons-${children} ${size}`} />);
  }
}

AIconInline.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.string,
  size: PropTypes.oneOf(Object.values(sizes)),
};
AIconInline.defaultProps = {
  icon: 'shopping-cart',
  size: NORMAL,
};
AIconInline.sizes = sizes;
export default AIconInline;

